import styled from "styled-components";
import Chip from "../Chip";
import ActionImageButton from "../DataTable/ActionImageButton";
import ListWithPagination from "../ListsWithPagination";
import Table from "../DataTable";

interface Props {
  data: any;
  isTableDataLoading: boolean;
  onEdit: (id: string) => void;
}

const PrivilegeAccountTable = ({ data, isTableDataLoading, onEdit }: Props) => {
  const columns = [
    {
      path: "name",
      label: "Event Title",
    },
    {
      path: "discount",
      label: "% Discount",
    },
    {
      key: "status",
      label: "Status",
      content: (account: { status: boolean }) => (
        <Chip
          label={account.status ? "Active" : "In active"}
          variant={account.status ? "success" : "error"}
        />
      ),
    },
    {
      label: "Action",
      key: "action",
      content: (account: any) => (
        <ActionImageButton
          onClick={() => onEdit(account.id)}
          iconPath={require("../../assets/images/edit-icon.png")}
          label={"Action"}
        />
      ),
    },
  ];
  return (
    <>
      <TableWrapper>
        <Table
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={""}
          hidePagination={true}
          currentPage={0}
          totalData={0}
          rowsPerPage={0}
          onPageChange={function (page: number): void {
            throw new Error("Function not implemented.");
          }}
        />
      </ListWrapper>
    </>
  );
};

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;
const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default PrivilegeAccountTable;
